export default __webpack_public_path__ + "static/media/eb-ultra-wht-banner-3.ad6eece2.jpg";